import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "../../sidebar";
import { useModalContext } from "../../CustomModal/ModalProvider.jsx";
import Swal from "sweetalert2";

import {
  MainContainer,
  Title,
  HeaderSection,
  Row,
  Label,
  RightColumn,
  LeftColumn,
  ContentWrapper,
  StyledButton,
  ShowInput,
  StyledSelect,
  FormContainer,
  SideContainer,
  CardImage,
  ButtonContainerRight,
  ButtonContainerLeft,
  FileInput,
  RemoveButton,

  ArquivoAtual,
  ArquivoEscolhido,
  FileInputWrapper,
  FileInputButton,
  HiddenFileInput
} from "./styles";
import { useRef } from "react";
import { projectService } from "../../../services/projectService.js";
import { userService } from "../../../services/userService.js";
import { guardianAreaService } from "../../../services/guardianAreaService.js";

const EditArea = () => {
  const { id_code } = useParams();
  const navigate = useNavigate();
  const { showEditConfirm, showWarning } = useModalContext();



  const fileInputRef = useRef(null);


  const [area, setArea] = useState(null);
  const [options, setOptions] = useState({ projects: [], users: [] });
  const [formData, setFormData] = useState({
    name: "",
    project: "",
    vert_responsible: "",
    adi_responsible: "",
    other_responsibles: [],
    adi_image: null,
  });

  useEffect(() => {
    const fetchData = async () => {
      // Adicione esta verificação
      if (!id_code) {
        console.error("❌ id_code está undefined!");
        return;
      }

      try {
        const [areaRes, projectsRes, usersRes] = await Promise.all([
          guardianAreaService.getGuardianAreaById(id_code), // ← CORRIGIDO: passe o id_code
          projectService.getProjects(),
          userService.getUsers(),
        ]);

        // Ajuste conforme a estrutura real da sua API
        const areaData = areaRes.data || areaRes;
        const projectsData = projectsRes.data || projectsRes;
        const usersData = usersRes.data || usersRes;

        setArea(areaData);
        setOptions({
          projects: Array.isArray(projectsData)
            ? projectsData
            : Array.isArray(projectsData?.projects_project)
              ? projectsData.projects_project
              : [],
          users: Array.isArray(usersData)
            ? usersData
            : Array.isArray(usersData?.results)
              ? usersData.results
              : [],
        });

        // project no update precisa do ID numérico (API PrimaryKey)
        const projectId =
          areaData.project_detail?.id ??
          areaData.project?.id ??
          areaData.project ??
          "";

        setFormData({
          name: areaData.name || "",
          project: projectId,
          vert_responsible: areaData.vert_responsible?.id ?? areaData.vert_responsible ?? "",
          adi_responsible: areaData.adi_responsible?.id ?? areaData.adi_responsible ?? "",
          matricula_status: areaData.matricula_status || "",
          total_area: areaData.total_area ?? "",
          legal_reserve_area: areaData.legal_reserve_area ?? "",
          reserve_legal_status: areaData.reserve_legal_status || "",
          georeferencing_status: areaData.georeferencing_status || "",
          sicar_code: areaData.sicar_code || "",
          status_car: areaData.status_car || "",
          other_responsibles: Array.isArray(areaData.other_responsibles)
            ? areaData.other_responsibles.map((r) => (typeof r === "object" ? r.id : r))
            : [],
          adi_image: areaData.adi_image || null,
        });

      } catch (error) {
        console.error("❌ Erro ao carregar dados:", error);
        // Mostra alerta para o usuário
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Não foi possível carregar os dados da área."
        });
      }
    };

    fetchData();
  }, [id_code]); // Certifique-se de que id_code está na dependência

  const handleSave = async (e) => {
    e.preventDefault();

    // Verifique se a área e id_code existem
    if (!area || !area.id_code) {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Dados da área não carregados corretamente."
      });
      return;
    }

    // 🔹 Exibe o Swal com textarea para o motivo da edição
    const { value: edit_reason } = await Swal.fire({
      title: "Confirmação de Edição",
      input: "textarea",
      inputLabel: "Descreva o motivo da edição:",
      inputPlaceholder: "Digite aqui o motivo...",
      inputAttributes: {
        "aria-label": "Motivo da edição"
      },
      showCancelButton: true,
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
      inputValidator: (value) => {
        if (!value) {
          return "Você precisa descrever o motivo da edição!";
        }
      }
    });

    if (!edit_reason) {
      return;
    }

    try {

      const response = await guardianAreaService.updateGuardianArea(
        area.id_code,
        formData,
        edit_reason
      );

      await Swal.fire({
        icon: "success",
        title: "Área atualizada com sucesso!",
        showConfirmButton: false,
        timer: 2000
      });

      navigate(`/areas`);

    } catch (error) {
      console.error('❌ Erro ao atualizar área:', error);
      console.error('📋 Detalhes do erro:', error.response?.data);

      Swal.fire({
        icon: "error",
        title: "Erro ao atualizar área",
        text: error.response?.data?.detail || error.response?.data?.error || "Verifique os dados e tente novamente."
      });
    }
  };

  // Manipula mudança nos campos
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Manipula upload de imagem
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({ ...prev, adi_image: file }));
  };

  const handleCancel = () => {
    navigate(`/area_details/${id_code}`);
  };


  if (!area)
    return (
      <MainContainer>
        <Sidebar />
        <SideContainer>
          <p>Carregando dados da área...</p>;
        </SideContainer>
      </MainContainer>
    );

  return (
    <MainContainer>
      <Sidebar />
      <SideContainer>
        <ContentWrapper>
          <ButtonContainerLeft>
            <StyledButton onClick={handleCancel}>Voltar</StyledButton>
          </ButtonContainerLeft>

          <HeaderSection>
            <Title>Editar Área</Title>
          </HeaderSection>

          <FormContainer onSubmit={handleSave}>
            <ButtonContainerRight>
              <StyledButton type="submit">Salvar Alterações</StyledButton>
            </ButtonContainerRight>

            <Row>
              <LeftColumn>
                <Label>Imagem ADI:</Label>
              </LeftColumn>

              <RightColumn>
                {/* Arquivo atual */}
                {formData?.adi_image && (
                  <ArquivoAtual>
                    Arquivo atual:{" "}
                    {typeof formData.adi_image === "string"
                      ? formData.adi_image.split("/").pop()
                      : "Arquivo carregado"}
                  </ArquivoAtual>
                )}

                {/* Arquivo selecionado */}
                {formData?.adi_image && typeof formData.adi_image === "object" && (
                  <ArquivoEscolhido>
                    Arquivo selecionado: {formData.adi_image.name}
                  </ArquivoEscolhido>
                )}

                {/* Botão estilizado */}
                <FileInputWrapper>
                  <FileInputButton
                    type="button"
                    onClick={() => fileInputRef.current?.click()}
                  >
                    Selecionar Arquivo
                  </FileInputButton>

                  <HiddenFileInput
                    ref={fileInputRef}
                    type="file"
                    name="adi_image"
                    accept=".jpg,.jpeg,.png"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        setFormData((prev) => ({
                          ...prev,
                          adi_image: file,
                          remove_adi_image: false,
                        }));
                      }
                    }}
                  />
                </FileInputWrapper>

                {/* Botão remover */}
                {formData?.adi_image && (
                  <RemoveButton
                    type="button"
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        adi_image: null,
                        remove_adi_image: true,
                      }))
                    }
                    title="Remover imagem"
                  >
                    ✕
                  </RemoveButton>

                )}
              </RightColumn>
            </Row>



            <Row>
              <LeftColumn><Label>Nome da Área:</Label></LeftColumn>
              <RightColumn>
                <ShowInput
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </RightColumn>
            </Row>

            <Row>
              <LeftColumn><Label>Projeto:</Label></LeftColumn>
              <RightColumn>
                <StyledSelect
                  name="project"
                  value={formData.project || ""}
                  onChange={handleChange}
                  disabled   // ← ADICIONE ESTA LINHA
                >
                    <option  value={formData.project}>
                     {formData.project}
                    </option>
                </StyledSelect>
              </RightColumn>
            </Row>

            <Row>
              <LeftColumn><Label>Responsável VERT:</Label></LeftColumn>
              <RightColumn>
                <StyledSelect
                  name="vert_responsible"
                  value={formData.vert_responsible}
                  onChange={handleChange}
                >
                  {options.users
                    .filter((user) => user.user_type === "ADM" || user.user_type === "ENG")
                    .map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.full_name}
                      </option>
                    ))}
                </StyledSelect>
              </RightColumn>
            </Row>

            <Row>
              <LeftColumn><Label>Gestor:</Label></LeftColumn>
              <RightColumn>
                <StyledSelect
                  name="adi_responsible"
                  value={formData.adi_responsible}
                  onChange={handleChange}
                >
                  {options.users
                    .filter((user) => user.user_type === "GUARDIAN" ||
                    user.user_type === "PROP")
                    .map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.full_name}
                      </option>
                    ))}
                </StyledSelect>
              </RightColumn>
            </Row>

            <Row>
              <LeftColumn>
                <Label>Equipe Responsável (outros):</Label>
              </LeftColumn>
              <RightColumn>
                {/* Select para adicionar usuários */}
                <StyledSelect
                  id="other_responsibles"
                  name="other_responsibles"
                  value=""
                  onChange={(e) => {
                    const selectedId = Number(e.target.value);
                    if (!selectedId) return;

                    // Evita duplicidade e mantém limite de 5
                    if (formData.other_responsibles.includes(selectedId)) return;

                    if (formData.other_responsibles.length < 5) {
                      setFormData((prev) => ({
                        ...prev,
                        other_responsibles: [...prev.other_responsibles, selectedId],
                      }));
                    } else {
                      showWarning("Limite atingido", "Você só pode selecionar até 5 usuários.");
                    }
                  }}
                >
                  <option value="">Selecione mais usuários</option>
                  {options.users
                    .filter((user) => user.user_type === "GUARDIAN")
                    .filter((user) => !formData.other_responsibles.includes(user.id))
                    .map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.full_name}
                      </option>
                    ))}
                </StyledSelect>

                {/* Tags com usuários selecionados */}
                {formData.other_responsibles.length > 0 && (
                  <div
                    style={{
                      marginTop: "8px",
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "4px",
                    }}
                  >
                    {formData.other_responsibles.map((id) => {
                      const user = options.users.find((u) => u.id === id); // agora vai bater
                      return (
                        <div
                          key={id}
                          style={{
                            background: "var(--surface-2)",
                            padding: "4px 8px",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {user?.full_name}
                          <span
                            onClick={() =>
                              setFormData((prev) => ({
                                ...prev,
                                other_responsibles: prev.other_responsibles.filter(
                                  (uid) => uid !== id
                                ),
                              }))
                            }
                            style={{
                              marginLeft: "8px",
                              cursor: "pointer",
                              fontWeight: "bold",
                            }}
                          >
                            ×
                          </span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </RightColumn>
            </Row>
          </FormContainer>
        </ContentWrapper>
      </SideContainer>
    </MainContainer>
  );
};

export default EditArea;
